import request from "@/utils/request";
import base from './base';
import Cookies from 'js-cookie';
import axios from 'axios';

// 删除原有的 host 定义
export const host = base.api_data;

// 定义接口
// export const host = "http://127.0.0.1:8000"; // 代理请求
const api_login = '/login/login/';  // 登录
const api_login_captcha = '/login/captcha/'; // 验证码
const api_save = '/login/save/';  // 个人中心
const api_updateUserPwd = '/login/updateUserPwd/';  // 修改密码
const api_search = '/login/search/';  // 用户管理列表-分页-搜索
const api_action = '/login/action/'; // 用户管理列表-操作
const api_resetPassword = '/login/resetPassword/'; // 重置密码
const api_status = '/login/status/';//用户状态修改
const api_check = '/login/check/'; // 权限校验查重
const api_grantrole = '/login/grantrole/';//分配角色
const api_grantgroup = '/login/grantgroup/';//分配分组
const api_menu_listall = '/menu/listall/';//查询用户角色
const api_menu_search = '/menu/search/';//角色管理列表-分页-搜索
const api_menu_save = '/menu/save/';//角色管理列表-新增
const api_menu_action = '/menu/action/';//角色管理列表-操作
const api_menu_check = '/menu/check/'; // 权限校验查重
const api_menu_treeList = '/menu/treeList/';//查询菜单树
const api_menu_menus = '/menu/menus/';//根据用户查找菜单zaor权限
const api_menu_grant = '/menu/grant/';//角色授权

// 添加企业微信登录相关接口
const api_work_wechat_qrcode = '/login/work_wechat/qrcode/'; // 获取企业微信登录二维码
const api_work_wechat_login = '/login/work_wechat/check_login/'; // 检查企业微信登录状态
const api_work_wechat_callback = '/login/work_wechat/callback/'; // 企业微信登录回调
const api_work_wechat_bind = '/login/work_wechat/bind/'; // 企业微信账号绑定
const api_work_wechat_login_callback = '/login/work_wechat/login_callback/'; // 企业微信登录回调
const api_getUserInfo = '/login/getUserInfo/'; // 获取用户信息

const api_group_listall = '/store/listall/';//查询用户分组
const api_group_search = '/store/search/';//角色管理列表-分页-搜索
const api_group_save = '/store/save/';//角色管理列表-新增
const api_group_action = '/store/action/';//角色管理列表-操作
const api_group_check = '/store/check/'; // 权限校验查重
const api_group_treeList = '/store/treeList/';//查询菜单树 温州大区-温州一区 ——强强店 
const api_group_treeLists = '/store/treeLists/';//查询菜单树 温州大区-温州一区 ——强强店  带用户权限
const api_group_build_region_tree = '/store/build_region_tree/';//查询菜单树
const api_group_stores = '/store/stores/';//根据用户查找菜单zaor权限
const api_group_grant = '/store/grant/';//分组授权


//上传图片
// export const uploadUrl='/api//upload';--
export default {
    // 登录
    api_login(params) {
        console.log('登录请求参数:', params);
        // 检查params是否是FormData类型
        if (params instanceof FormData) {
            // 直接发送FormData对象
            return request.post(`${host}${api_login}`, params);
        } else {
            // 向后兼容，支持以前的JSON对象方式
            return request.post(`${host}${api_login}`, params);
        }
    },
    //验证码
    api_login_captcha(params) {
        console.log('请求验证码API');
        return request.get(`${host}${api_login_captcha}`, { params })
            .then(response => {
                console.log('验证码API响应:', response);
                // 直接返回后端原始响应，不做额外处理
                return response;
            })
            .catch(error => {
                console.error('验证码API错误:', error);
                throw error;
            });
    },
    //个人中心
    api_save(params) {
        return request.post(`${host}${api_save}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    //修改密码
    api_updateUserPwd(params) {
        return request.post(`${host}${api_updateUserPwd}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    //用户管理列表-分页-搜索
    api_search(params) {
        return request.post(`${host}${api_search}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    //用户管理列表-操作
    api_action(params, method = 'delete') {
        if (method === 'DELETE') {
            return request.delete(`${host}${api_action}`, { data: params });
        } else {
            const queryString = Object.entries(params)
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                .join('&');
            return request.get(`${host}${api_action}?${queryString}`);
        }
    },
    api_resetPassword(params) {
        return request.get(`${host}${api_resetPassword}`, { params });
    },

    api_status(params) {
        return request.post(`${host}${api_status}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    // 权限校验
    api_check(params) {
        return request.post(`${host}${api_check}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    // 分配角色
    api_grantrole(params) {
        return request.post(`${host}${api_grantrole}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    // 分配分组
    api_grantgroup(params) {
        return request.post(`${host}${api_grantgroup}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    //_____________________________________________________________________________________________
    // 查询用户角色
    api_menu_listall(params) {
        return request.get(`${host}${api_menu_listall}`, { params });
    },
    api_menu_search(params) {
        return request.post(`${host}${api_menu_search}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    //角色管理列表-分页-搜索
    api_menu_save(params) {
        return request.post(`${host}${api_menu_save}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    //用户管理列表-操作
    api_menu_action(params, method = 'delete') {
        if (method === 'DELETE') {
            return request.delete(`${host}${api_menu_action}`, { data: params });
        } else {
            const queryString = Object.entries(params)
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                .join('&');
            return request.get(`${host}${api_menu_action}?${queryString}`);
        }
    },

    // _____________________________________________________________
    // 权限校验
    api_menu_check(params) {
        return request.post(`${host}${api_menu_check}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    // 菜单列表获取菜单树
    api_menu_treeList(params) {
        return request.get(`${host}${api_menu_treeList}`, { params });
    },
    // 根据角色查询菜单权限
    api_menu_menus(params) {
        return request.get(`${host}${api_menu_menus}`, { params });
    },
    //角色权限授权
    api_menu_grant(params) {
        return request.post(`${host}${api_menu_grant}`, params);
    },


    // 查询用户分组
    api_group_listall(params) {
        return request.get(`${host}${api_group_listall}`, { params });
    },
    api_group_search(params) {
        return request.post(`${host}${api_group_search}`, JSON.stringify(params), { 
            headers: { 'Content-Type': 'application/json' },
            transformResponse: [
                function(data) {
                    try {
                        // 尝试解析JSON
                        return JSON.parse(data);
                    } catch (e) {
                        // 如果不是有效的JSON，返回原始数据
                        console.error('解析响应JSON失败:', e);
                        return data;
                    }
                }
            ]
        });
    },
    //角色管理列表-分页-搜索
    api_group_save(params) {
        return request.post(`${host}${api_group_save}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    //用户管理列表-操作
    api_group_action(params, method = 'delete') {
        if (method === 'DELETE') {
            return request.delete(`${host}${api_group_action}`, { data: params });
        } else {
            const queryString = Object.entries(params)
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                .join('&');
            return request.get(`${host}${api_group_action}?${queryString}`);
        }
    },
    // _____________________________________________________________
    // 权限校验
    api_group_check(params) {
        return request.post(`${host}${api_group_check}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    // 分组授权
    api_group_grant(params) {
        return request.post(`${host}${api_group_grant}`, params);
    },

    // 菜单列表获取菜单树
    api_group_treeList(params) {
        return request.get(`${host}${api_group_treeList}`, { params });
    },
    // 菜单列表获取菜单树  带权限
    api_group_treeLists(params) {
        return request.get(`${host}${api_group_treeLists}`, { params });
    },
    // 根据分组查询菜单权限
    api_group_build_region_tree(params) {
        return request.get(`${host}${api_group_build_region_tree}`, { params });
    },
    // 根据角色查询菜单权限
    api_group_stores(params) {
        return request.get(`${host}${api_group_stores}`, { params });
    },

    // 企业微信登录相关接口
    // 获取企业微信登录二维码
    api_work_wechat_qrcode() {
        return request.get(`${host}${api_work_wechat_qrcode}`, {
            transformResponse: [
                function(data) {
                    try {
                        return JSON.parse(data);
                    } catch (e) {
                        console.error('解析企业微信二维码响应失败:', e);
                        return data;
                    }
                }
            ]
        });
    },
    // 检查企业微信登录状态
    api_work_wechat_login(params) {
        console.log('检查企业微信登录状态, 参数:', params);
        return request.post(`${host}${api_work_wechat_login}`, JSON.stringify(params), { 
            headers: { 'Content-Type': 'application/json' },
            transformResponse: [
                function(data) {
                    try {
                        const parsedData = JSON.parse(data);
                        console.log('检查登录状态响应:', parsedData);
                        return parsedData;
                    } catch (e) {
                        console.error('解析企业微信登录状态响应失败:', e);
                        return data;
                    }
                }
            ]
        });
    },
    // 企业微信登录回调
    api_work_wechat_login_callback(params) {
        console.log('企业微信登录回调, 参数:', params);
        return request.get(`${host}${api_work_wechat_login_callback}`, { 
            params,
            transformResponse: [
                function(data) {
                    try {
                        return JSON.parse(data);
                    } catch (e) {
                        console.error('解析企业微信登录回调响应失败:', e);
                        return data;
                    }
                }
            ]
        });
    },
    // 企业微信账号绑定
    api_work_wechat_bind(params) {
        console.log('绑定企业微信账号, 参数:', params);
        return request.post(`${host}${api_work_wechat_bind}`, JSON.stringify(params), { 
            headers: { 'Content-Type': 'application/json' },
            transformResponse: [
                function(data) {
                    try {
                        return JSON.parse(data);
                    } catch (e) {
                        console.error('解析企业微信账号绑定响应失败:', e);
                        return data;
                    }
                }
            ]
        });
    },

    // 获取用户信息
    api_getUserInfo(userId) {
        // 构建请求URL，如果有userId则添加到URL参数中
        let url = `${host}/login/getUserInfo/`;
        if (userId) {
            url += `?user_id=${userId}`;
        }
        
        console.log('请求获取用户信息:', url);
        
        // 获取当前token，确保请求头中有token
        const token = window.sessionStorage.getItem('token') || 
                     window.localStorage.getItem('token') ||
                     Cookies.get('token');
        
        if (!token) {
            console.error('获取用户信息失败: 没有可用的token');
            return Promise.reject(new Error('没有可用的token'));
        }
        
        // 添加请求头中的token
        const headers = {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
        
        console.log('请求获取用户信息，使用token:', token.substring(0, 15) + '...');
        
        return axios({
            method: 'get',
            url: url,
            headers: headers,
            timeout: 15000, // 增加超时时间到15秒
            transformResponse: [
                function(data) {
                    try {
                        // 尝试解析JSON
                        const parsed = JSON.parse(data);
                        console.log('用户信息原始数据:', parsed);
                        
                        // 验证响应中是否包含必要的字段
                        if (parsed.code === 200) {
                            if (!parsed.user) {
                                console.error('用户信息响应缺少user字段');
                                return { 
                                    code: 500, 
                                    msg: '响应数据格式错误: 缺少user字段', 
                                    originalData: parsed 
                                };
                            }
                            
                            if (!parsed.menuList) {
                                console.warn('用户信息响应缺少menuList字段');
                                parsed.menuList = [];
                            }
                            
                            if (!parsed.perms) {
                                console.warn('用户信息响应缺少perms字段');
                                parsed.perms = [];
                            }
                            
                            // 确保所有字段都存在
                            parsed.user = parsed.user || {};
                            parsed.menuList = parsed.menuList || [];
                            parsed.perms = parsed.perms || [];
                            parsed.roles = parsed.roles || '';
                        }
                        
                        return parsed;
                    } catch (e) {
                        console.error('解析用户信息响应失败:', e);
                        console.error('原始响应数据:', data);
                        return { code: 500, msg: '解析响应数据失败', error: e.message, rawData: data };
                    }
                }
            ]
        })
        .then(response => {
            console.log('用户信息响应成功:', response.status);
            return response.data;
        })
        .catch(error => {
            console.error('获取用户信息请求失败:', error);
            // 格式化错误响应
            return { 
                code: error.response?.status || 500, 
                msg: `获取用户信息失败: ${error.message}`,
                error: error
            };
        });
    },
};



